import { takeEvery, all, call, put } from 'redux-saga/effects';
import * as types from './yarnActionTypes';
import * as actions from './yarnActions';
import * as endpoints from '../../services/endpoints';
import * as alert from '../alert/alertActions';
import { errorHandler } from '../../helpers/errorHandler';

function* getYarnSaga(action) {
  console.log("🧵 [SAGA] getYarnSaga tetiklendi:", action);

  try {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const payload = {
      SessionUserId: sessionUserId,
      ...(action.payload || {})
    };

    if (!payload.SessionUserId) {
      console.warn("🚫 SessionUserId bulunamadı!");
      return;
    }

    const { data } = yield call(endpoints.getYarns, payload);
    console.log("🎯 GetYarn yanıtı:", data);
    yield put(actions.getYarnDataAction(data));
  } catch (e) {
    console.error("❌ GetYarn error:", e);
    yield put(actions.getYarnErrorAction(e));
  }
}


function* createYarnSaga(action) {
  try {
    console.log('createYarnSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Create yarn API payload:', payload);
    
    const { data } = yield call(endpoints.createYarn, payload);
    console.log('Create yarn API response:', data);
    
    yield put(actions.createYarnDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: data.Result.ErrorDescription,
        variant: 'success',
      }));
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/yarn');
        }, 1500);
      }
    }
    
  } catch (e) {
    console.error('createYarnSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.createYarnErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* updateYarnSaga(action) {
  try {
    console.log('updateYarnSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Update yarn API payload:', payload);
    
    const { data } = yield call(endpoints.updateYarn, payload);
    console.log('Update yarn API response:', data);
    
    yield put(actions.updateYarnDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: data.Result.ErrorDescription,
        variant: 'success',
      }));
      yield put(actions.getYarnRequestAction());
      
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/yarn');
        }, 1000);
      }
    }
    
  } catch (e) {
    console.error('updateYarnSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.updateYarnErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* deleteYarnSaga(action) {
  try {
    const { data } = yield call(endpoints.deleteYarn, action.payload.data);
    yield put(actions.deleteYarnDataAction(data));
    if (data.Result?.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: data.Result.ErrorDescription,
        variant: 'success',
      }));
      yield put(actions.getYarnRequestAction());
    }
  } catch (e) {
    yield put(actions.deleteYarnErrorAction(e));
    yield call(errorHandler, e);
  }
}

export function* yarnSaga() {
  yield all([
    takeEvery(types.GET_YARN_REQUEST, getYarnSaga),
    takeEvery(types.CREATE_YARN_REQUEST, createYarnSaga),
    takeEvery(types.UPDATE_YARN_REQUEST, updateYarnSaga),
    takeEvery(types.DELETE_YARN_REQUEST, deleteYarnSaga),
  ]);
}
